module.exports = __webpack_public_path__ + "fonts/symantec@2x.5af64e1bf8f2e3fe86925637e10ab8c3.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/symantec@2x.png
// module id = 788
// module chunks = 9